import { useCallback, useState } from 'react';
/**
 * State хук, который отслеживает и позволяет изменять булево значение.
 *
 * @param defaultValue Начальное значение, по умолчанию false
 * @returns {ToggleResult}
 */
export function useToggle(defaultValue = false) {
    const [isOpen, setOpen] = useState(defaultValue);
    const setTruthy = useCallback(() => {
        setOpen(true);
    }, []);
    const setFalsy = useCallback(() => {
        setOpen(false);
    }, []);
    const toggle = useCallback(() => {
        setOpen(isOpen => !isOpen);
    }, []);
    return { isOpen, setTruthy, setFalsy, toggle };
}
